"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const taquito_1 = require("@taquito/taquito");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
class TokenClient {
    constructor(nodeUrl, tokenAddress) {
        this.tokenAddress = tokenAddress;
        this.tezos = new taquito_1.TezosToolkit(nodeUrl);
    }
    async getBalance(address) {
        const tokenContract = await this.tezos.contract.at(this.tokenAddress);
        const tokenStorage = await tokenContract.storage();
        const balance = await tokenStorage.balances.get(address);
        return balance === undefined ? new bignumber_js_1.default(0) : balance.balance;
    }
}
exports.default = TokenClient;
//# sourceMappingURL=token-client.js.map